import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-section">
          <h3>About Us</h3>
          
          <p>
            We provide high-quality products like Flat belt conveyor, truck loading, unloading conveyor, SS slat chain conveyor, modular belt conveyor, roller conveyor, screw conveyor  and more for various industries.
          </p>
        </div>
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="#product">Products</a></li>
            <li><a href="#service">Services</a></li>
            <li><a href="#brand">Partners</a></li>
            
          </ul>
        </div>
        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>Email: perutechcbe@gmail.com</p>
          <p>Phone: +91-9944550682</p>
          <p>Register Address : 3/A1E-2nd Floor,Ashokar Street, Srinagar,Vellalore , Coimbatore -641111</p>
          <p>Manufacturing Plant Address : 185/1, Room -B, Mahatmagandhi Road, SIHS colony - Irugur road, Coimbatore - 641014. </p>

        </div>
        {/* <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noreferrer">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div> */}
      </div>
      <div className="footer-bottom">
        <p>© 2025 Peru-Tech. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
